/* istanbul ignore file */

// cleanup_convert_to_typescript_file_GENERICS_IMPORT_MAP

import { createUseStyles } from '@glu/theming';

export default createUseStyles(
  ({
    palette: {
      colors: { tundora: black },
      common: { white },
      grey
    },
    spacing: { unit },
    typography
  }) => ({
    wrapper: {
      width: 300,
      margin: '0 auto'
    },
    extraHeaderOptions: {
      margin: [2.5 * unit, 6.25 * unit]
    },
    dropdown: {
      '& > label': {
        width: '100%'
      }
    },
    delimiter: {
      '& [class*="dropdown"]': {
        zIndex: 4
      }
    },
    endOfRecord: {
      '& [class*="dropdown"]': {
        zIndex: 3
      }
    },
    tableCheckbox: {
      display: 'flex',
      marginTop: 5,
      '& [class*="checkboxIcon-"][class*="selected-"]': {
        backgroundColor: black,
        '& svg': {
          stroke: white
        }
      }
    },
    checkboxWrapper: {
      display: 'flex',
      justifyContent: 'space-evenly',
      margin: [30, 0]
    },
    mapFormatLabel: {
      color: grey.G600,
      fontSize: 12,
      fontWeight: typography.fontWeightHeavy,
      marginBottom: 10,
      textTransform: 'uppercase'
    },
    mapFormat: {
      justifyContent: 'center'
    },
    alertsWrapper: {
      marginBottom: 3 * unit
    }
  })
);
